import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("hh_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("hh_token"); setUser(false); });
  }, []);

  const signIn = ({ token, user: u }) => { localStorage.setItem("hh_token", token); setUser(u); };
  const signOut = () => { localStorage.removeItem("hh_token"); setUser(false); };
  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data));

  return <AuthContext.Provider value={{ user, setUser, signIn, signOut, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
